import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const StyledFormGroup = styled(FormGroup)<{ $error?: string }>`
    .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0 !important;'}
    }
`;
